import { render, staticRenderFns } from "./AcceptUserAgreement.vue?vue&type=template&id=7ebaca25&scoped=true"
import script from "./AcceptUserAgreement.vue?vue&type=script&lang=ts"
export * from "./AcceptUserAgreement.vue?vue&type=script&lang=ts"
import style0 from "./AcceptUserAgreement.vue?vue&type=style&index=0&id=7ebaca25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.99.8__lodash@4.17.21_prettier@2.8.8_vue-_69bc0556815cefdff9c73fe5644cf446/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebaca25",
  null
  
)

export default component.exports